export function stickyHeader() {
  const stickyEl = document.querySelector('header.banner');
  const searchForm = document.querySelector('.search-form');
  const searchBtn = searchForm.querySelector('.js-search-submit-btn');
  const mediaQuery = window.matchMedia('(max-width: 767px)');
  let isStuck = false;
  let searchOpen = false;

  if (mediaQuery.matches) {
    return;
  }

  const getDistance = () => stickyEl.offsetTop;

  const showSearchForm = () => {
    searchForm.classList.add('is-open');

    const searchField = searchForm.querySelector('.js-search-input');
    searchField.addEventListener('keydown', (e) => {
      // Send form on enter
      if (e.keyCode === 13 || e.which === 13 || e.key === 'Enter') {
        searchForm.submit();
      }
    });
  };

  const hideSearchForm = () => {
    searchForm.classList.remove('is-open');
  };

  const handleSearch = (shouldBePrevented = true) => {
    function toggleSearch(event) {
      if (shouldBePrevented) {
        event.preventDefault();
      }

      searchOpen = !searchOpen;

      if (searchOpen) {
        showSearchForm();
      } else {
        hideSearchForm();
      }
    }

    if (searchForm) {
      searchBtn.addEventListener('click', toggleSearch);
    }
  };

  const setSticky = () => {
    stickyEl.classList.add('is-sticky');
    isStuck = true;

    handleSearch();
  };

  const removeSticky = () => {
    stickyEl.classList.remove('is-sticky');
    isStuck = false;

    handleSearch(false);
    hideSearchForm();
  };

  if (stickyEl) {
    if ((window.pageYOffset > 0) && !isStuck) {
      setSticky();
    }

    window.addEventListener('scroll', () => {
      const dist = getDistance() - window.pageYOffset;
      const offset = window.pageYOffset;

      if ((dist <= 0) && !isStuck) {
        setSticky();
      } else if (isStuck && (offset <= getDistance())) {
        removeSticky();
      }
    });
  }
}
